import Button from '@material-ui/core/Button'
import Fade from '@material-ui/core/Fade'
import Grid from '@material-ui/core/Grid'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import LanguageIcon from '@material-ui/icons/Language'
import React, { useState } from 'react'

import i18n from '../i18n/index'
import { specialTheme } from '../theme'
import { isDEV } from '../helpers'

const useStyles = makeStyles((theme) => ({
  language: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  textColor: {
    color: specialTheme.colors.dark,
  },
}))

const LanguageSwitch = () => {
  const classes = useStyles()

  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng)
    setAnchorEl(null)
  }

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  return (
    <Grid className={classes.language}>
      {isDEV && (
        <React.Fragment>
          <Button
            aria-controls="fade-menu"
            aria-haspopup="true"
            onClick={handleClick}
          >
            <LanguageIcon />
          </Button>
          <Menu
            id="fade-menu"
            anchorEl={anchorEl}
            keepMounted
            open={open}
            TransitionComponent={Fade}
          >
            <MenuItem onClick={() => changeLanguage('pl')}>
              <Typography className={classes.textColor}>PL</Typography>
            </MenuItem>
            <MenuItem onClick={() => changeLanguage('en')}>
              <Typography className={classes.textColor}>EN</Typography>
            </MenuItem>
          </Menu>
        </React.Fragment>
      )}
    </Grid>
  )
}

export default LanguageSwitch
